import { useContext, useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import "./Tab5Content.css";
import { AppThemeContext } from "../../../../../../context/AppThemeContext";

function UpdateInverter({ show, handleClose, userData, handleUpdate }) {
     const { PrimaryColor } = useContext(AppThemeContext);
    const [formData, setFormData] = useState({
        userId: "",
        // password: "",
        userName: "",
        modelNo: "",
        latitude: "",
        longitude: "",
        capacity: "",
        
    });

    useEffect(() => {
        if (userData) {
            setFormData({
                userId: userData.FEEDER_ID || "",
                // password: userData.PASSWORD || "",
                userName: userData.NAME || "",
                modelNo: userData.MODEL_NO || "",
                latitude: userData.Latitude || "",
                longitude: userData.Longitude || "",
                capacity: userData.KWP || "",
                
            });
        }
    }, [userData]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await fetch("/api/updateUser", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(formData),
            });

            if (!response.ok) {
                throw new Error("Failed to update user");
            }

            const updatedUser = await response.json();
            handleUpdate(updatedUser);
            handleClose();
        } catch (error) {
            console.error("Error updating user:", error);
        }
    };


    

    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton className="modal-header-custom" style={{backgroundColor:PrimaryColor}}>
                <Modal.Title>Update User Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleSubmit}>
                    <div className="row">
                        {/* User ID (Read-only) & Password */}
                        <div className="col-md-6">
                            <Form.Group className="mb-3">
                                <Form.Label style={{color:"black"}}>User ID</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="userId"
                                    value={formData.userId}
                                    readOnly
                                    className="readonly-input"
                                />
                            </Form.Group>
                        </div>

                        <div className="col-md-6">
                            <Form.Group className="mb-3">
                                <Form.Label style={{color:"black"}}>Name</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="userName"
                                    value={formData.userName}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                        </div>

                        {/* Location & Email */}
                        <div className="col-md-6">
                            <Form.Group className="mb-3">
                                <Form.Label style={{color:"black"}}>Model No</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="modelNo"
                                    value={formData.modelNo}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                        </div>
                        <div className="col-md-6">
                            <Form.Group className="mb-3">
                                <Form.Label style={{color:"black"}}>Capacity</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="capacity"
                                    value={formData.capacity}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                        </div>

                        {/* Latitude & Longitude */}
                        <div className="col-md-6">
                            <Form.Group className="mb-3">
                                <Form.Label style={{color:"black"}}>Latitude</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="latitude"
                                    value={formData.latitude}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                        </div>
                        <div className="col-md-6">
                            <Form.Group className="mb-3">
                                <Form.Label style={{color:"black"}}>Longitude</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="longitude"
                                    value={formData.longitude}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                        </div>

                        {/* User Name */}
                        {/* <div className="col-md-12">
                            <Form.Group className="mb-3">
                                <Form.Label>User Name</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="userName"
                                    value={formData.userName}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                        </div> */}

                        {/* Plant Commissioned Date */}
                        {/* <div className="col-md-12">
                            <Form.Group className="mb-3">
                                <Form.Label>Plant Commissioned Date</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="commissionDate"
                                    value={formData.commissionDate}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                        </div> */}
                        
                    </div>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button style={{backgroundColor:PrimaryColor}} onClick={handleClose}>
                    Cancel
                </Button>
                <Button style={{backgroundColor:PrimaryColor}} onClick={handleSubmit}>
                    Update
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default UpdateInverter;    